module.exports = __webpack_public_path__ + "896f947c00b9939be6125951da1225f8.mp3";